'use client';

import { createContext, useContext, type FC, type ReactNode } from 'react';
import { useNavigation as useNavigationHook } from '../hooks/useNavigation';

type NavigationType = ReturnType<typeof useNavigationHook>;

export const NavigationContext = createContext<NavigationType | undefined>(undefined);

export const NavigationProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const navigation = useNavigationHook();

  return <NavigationContext.Provider value={navigation}>{children}</NavigationContext.Provider>;
};

const NO_OP_NAVIGATION: NavigationType = {
  state: {
    activeTab: 'cases',
    stacks: {
      balance: [{ screen: 'balance' }],
      cases: [{ screen: 'cases' }],
      games: [{ screen: 'games' }],
      inventory: [{ screen: 'inventory' }],
      referrals: [{ screen: 'referrals' }],
      profile: [{ screen: 'profile' }],
      onboarding: [{ screen: 'onboarding' }],
      shop: [{ screen: 'shop' }],
    },
  },
  changeTab: () => {},
  pushScreen: () => {},
  replaceScreen: () => {},
  popScreen: () => {},
  resetStack: () => {},
  goBack: () => {},
  navigate: () => {},
  getCurrentScreen: () => ({ screen: 'cases' }),
  canGoBack: () => false,
  updateCurrentParams: () => {},
};

export const useNavigation = (): NavigationType => {
  const context = useContext(NavigationContext);
  return context ?? NO_OP_NAVIGATION;
};
